import { DashboardOutlined } from '@ant-design/icons'

export const MENU_LIST = [
  {
    key: 'overview',
    label: 'Overview',
    icon: <DashboardOutlined />,
  },
]
